/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:cdbcfb57-f7c0-4340-8686-9a6e9bcfbef3",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_IwLiozKzD",
    "aws_user_pools_web_client_id": "1q6vgfcft0063smegbm5fs11og",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://y6zgbqp7hzfuneonqqsoaokyx4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-blwgxruprzfsnfphsh75bt4gua",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://73guimgwjf.execute-api.us-east-2.amazonaws.com/test",
            "region": "us-east-2"
        },
        {
            "name": "vqaasapi",
            "endpoint": "https://cb73s8ilu0.execute-api.us-east-2.amazonaws.com/test",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "vqaas-storage94935-test",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
